const Web3 = require('web3');
const abi = require('./abi.js');
let bigInt = require("big-integer");

const contract_address = "0xD65bf22A332E8FD242Dc60CB83D71fbfA9050bA3"

class Web3Adapter {
    constructor(cb) {
        this.cb = cb
        this.web3 = false;
        this.contract = false;
        this.abi = abi;
    }
    async init(provider) {
        if (!provider) {
            return;
        }
        try {
            this.web3 = new Web3(provider);
            this.contract = new this.web3.eth.Contract(this.abi, contract_address);
            this.cb.call(this, "connected", "connected")
        }
        catch(ex) {
            this.cb.call(this, "error", "Could not connect")
            return;
        }
    }

    async purchase(amount) {
        try {
            if (amount > 5) {
                throw "Attempting to buy too many"
            }
            let price = bigInt("50000000000000000").multiply(amount)
            let account = await this.web3.eth.getAccounts();
            account = account[0]
            await this.contract.methods["mint"](amount).send({from: account, value: price.toString()})
            let supply = await this.remaining();
            this.cb.call(this, "purchased", supply)
        }
        catch(ex) {
            try {
                if (amount > 5) {
                    throw "Attempting to buy too many"
                }
                let price = bigInt("50000000000000000").multiply(amount)
                let gasPrice = await this.web3.eth.getGasPrice();
                let account = await this.web3.eth.getAccounts();
                account = account[0]
                let gasEst = await this.contract.methods["mint"](amount).estimateGas({from: account, value: price.toString(), gasPrice: gasPrice})
                await this.contract.methods["mint"](amount).send({from: account, value: price.toString(), gasPrice: gasPrice, gas: gasEst})
                let supply = await this.remaining();
                this.cb.call(this, "purchased", supply)
            }
            catch(ex) {
                console.log(ex)
                this.cb.call(this, "error", "Could not complete purchase")
            }
        }
    }
    async remaining() {
        try {
            let supply = await this.contract.methods["totalSupply"]().call({gas: "50000000"})
            let remaining = 3333 - supply;
            return remaining;
        }
        catch(ex) {
            this.cb.call(this, "error", "")
            return '-'
        }
    }
}

export default Web3Adapter;